import { render } from "./AdminSchedules.vue?vue&type=template&id=23f5d9a8&scoped=true"
import script from "./AdminSchedules.vue?vue&type=script&lang=js"
export * from "./AdminSchedules.vue?vue&type=script&lang=js"

import "./AdminSchedules.vue?vue&type=style&index=0&id=23f5d9a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f5d9a8"]])

export default __exports__